import React from 'react';
import SMSearchMapRoomView from './SMSearchMapRoomView';
import SMMapHelper from 'components/helpers/SMMapHelper';
import SMRoomMarker from 'lib/SMRoomMarker';

class SMSearchMapView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedRoom: null,
      isCheckedMapMoveSearch: false,
      isVisibleMapReloadButton: false,
    };
    this.markers = [];
    this.visitedRooms = [];
    this.isZoomChanging = false;
  }

  componentDidMount() {
    // googleのライブラリ(https://maps.google.com/hoge.js)がサーバーサイドレンダリングの際に
    // 読み込めないため、個別に動くタイミングでprototypeを後付する必要がある
    this.addProtoTypeToMarker();
    this.geocoder = new google.maps.Geocoder();

    const $canvas = $(this.refs.mapCanvas);
    $canvas.height($(window).height() - $canvas.offset().top);

    let zoom;
    if (this.props.geocode) {
      const geocodes = this.props.geocode.split(",");
      this.position = new google.maps.LatLng(geocodes[0], geocodes[1]);
      zoom = SMMapHelper.getZoomByRadius(geocodes[2]);
    } else {
      this.position = SMMapHelper.defaultPosition();
      zoom = 8;
    }

    this.googleMap = SMMapHelper.googleMap(this.refs.mapCanvas, this.position, parseInt(zoom), {draggable: true});

    //カスタムコントロール
    this.activeMapMovedButton();

    this.googleMap.map.addListener('dragend', (e)=>{
      const position = this.googleMap.map.getCenter();
      if(this.props.delegate && typeof this.props.delegate.mapCenterDidChange === 'function'){
        this.props.delegate.mapCenterDidChange(position);
      }
    });
    this.googleMap.map.addListener('zoom_changed', (e)=>{
      if (this.isZoomChanging) {
        this.isZoomChanging = false;
        return;
      }
      // 初回ズーム時に絞り込みが行われないことを考慮してpositionも取得する
      const position = this.googleMap.map.getCenter();
      const zoom = this.googleMap.map.getZoom();
      if(this.props.delegate && typeof this.props.delegate.mapZoomDidChange === 'function'){
        this.props.delegate.mapZoomDidChange(zoom, position);
      }
    });
    this.updateMarkers();
  }

  // 地図を動かしながら検索ボタン生成
  createMapMoveSearchControl(controlDiv, map) {
    let controlUi = document.createElement('div');
    controlDiv.appendChild(controlUi);

    let searchCheckbox = document.createElement('input');
    searchCheckbox.id = 'search-list__checkbox';
    searchCheckbox.type = 'checkbox';
    controlUi.appendChild(searchCheckbox);

    let searchLabel = document.createElement('label');
    searchLabel.id = 'search-list__checkbox_label';
    searchLabel.for = 'search-list__checkbox';
    searchLabel.className = 'search-list__map-search-move form-checkbox__s';
    controlUi.appendChild(searchLabel);

    let pelem = document.createElement('p');
    const searchText = document.createTextNode('地図を動かしながら検索');
    pelem.appendChild(searchText);
    searchLabel.appendChild(pelem);

    controlUi.addEventListener('click', this.clickMapMoveSearchButton.bind(this));

    return controlDiv;
  }

  // 再検索をかけるボタン生成
  createMapReloadSearchControl(controlDiv, map) {
    let controlUi = document.createElement('div');
    controlDiv.appendChild(controlUi);

    let pelem = document.createElement('p');
    pelem.id = "search-list__reload_map";

    let refreshIcon = document.createElement('i');
    refreshIcon.className = 'fa fa-refresh mr5';

    const pelemText = document.createTextNode('再検索をかける');
    pelem.className = 'search-list__map-search-again button-green';
    pelem.appendChild(refreshIcon);
    pelem.appendChild(pelemText);
    controlUi.appendChild(pelem);

    controlUi.addEventListener('click', this.clickMapReloadSearchButton.bind(this));

    return controlDiv;
  }

  clickMapMoveSearchButton() {
    if (this.state.isCheckedMapMoveSearch) {
      this.setState({
        isCheckedMapMoveSearch: false,
      });
      document.getElementById('search-list__checkbox').checked = false;
    } else {
      this.setState({
        isCheckedMapMoveSearch: true,
      });
      document.getElementById('search-list__checkbox').checked = true;
    }

    if (this.props.delegate && typeof this.props.delegate.clickMapMoveSearchButton === 'function') {
      this.props.delegate.clickMapMoveSearchButton(this.state.isCheckedMapMoveSearch);
    }
  }

  activeMapReloadButton() {
    if (!this.state.isCheckedMapMoveSearch && !this.state.isVisibleMapReloadButton) {
      let mapReloadSearchControlDiv = document.createElement('div');
      const mapReloadSearchControl = this.createMapReloadSearchControl(mapReloadSearchControlDiv, this.googleMap.map);
      mapReloadSearchControlDiv.index = 1;
      this.googleMap.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].clear();
      this.googleMap.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(mapReloadSearchControlDiv);
      this.setState({
        isVisibleMapReloadButton: true,
      });
    }
  }

  clickMapReloadSearchButton() {
    if (this.props.delegate && typeof this.props.delegate.clickMapReloadSearchButton === 'function') {
      this.props.delegate.clickMapReloadSearchButton();
    }
    this.activeMapMovedButton();
  }

  activeMapMovedButton() {
    let mapMoveSearchControlDiv = document.createElement('div');
    const mapMoveSearchControl = this.createMapMoveSearchControl(mapMoveSearchControlDiv, this.googleMap.map);
    mapMoveSearchControlDiv.index = 1;
    this.googleMap.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].clear();
    this.googleMap.map.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(mapMoveSearchControlDiv);
    this.setState({
      isVisibleMapReloadButton: false,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.geocode != this.props.geocode) {
      let zoom = 8;
      this.position = SMMapHelper.defaultPosition();
      if (this.props.geocode) {
        const geocodes = this.props.geocode.split(",");
        this.position = new google.maps.LatLng(geocodes[0], geocodes[1]);
        zoom = SMMapHelper.getZoomByRadius(geocodes[2]);
      } else if (prevProps.geocode && this.props.location != null && this.props.location != "") {
        // エリア変更時に一瞬デフォルトのマップに戻らないように前の地図情報を再設定する
        const geocodes = prevProps.geocode.split(",");
        this.position = new google.maps.LatLng(geocodes[0], geocodes[1]);
        zoom = SMMapHelper.getZoomByRadius(geocodes[2]);
      }
      this.isZoomChanging = true;
      this.googleMap.map.panTo(this.position);
      this.googleMap.map.setZoom(zoom);
    }
    if (prevProps.rooms != this.props.rooms ||
        prevProps.mouseEnterRoom != this.props.mouseEnterRoom ||
        prevState.selectedRoom != this.state.selectedRoom) {
      this.updateMarkers();
    }

    if (prevProps.isMovedMap != this.props.isMovedMap) {
      this.activeMapReloadButton();
      if (this.props.delegate && typeof this.props.delegate.clearMapMovedFlag === 'function') {
        this.props.delegate.clearMapMovedFlag();
      }
    }
  }

  addProtoTypeToMarker() {
    SMRoomMarker.prototype = new google.maps.OverlayView();
    SMRoomMarker.prototype.draw = function() {
    	let dom = this.dom;
    	if (!dom) {
    		dom = this.dom = $('<a href="#" class="js-marker"><div class="search-list__map-baloon '+ this.className +'"><p>'+ this.room.min_price_text +'</p></div></a>').get(0);

    		if (typeof (this.args.marker_id) !== 'undefined') {
    			dom.dataset.marker_id = this.args.marker_id;
    		}
    		google.maps.event.addDomListener(dom, "click", (event)=> {
    			google.maps.event.trigger(this, "click");
    		});
    		let panes = this.getPanes();
    		panes.overlayImage.appendChild(dom);
    	}

    	let point = this.getProjection().fromLatLngToDivPixel(this.latlng);

    	if (point) {
    		dom.style.left = (point.x - 0) + 'px';
    		dom.style.top = (point.y - 0) + 'px';
    	}
    };

    SMRoomMarker.prototype.remove = function() {
    	if (this.dom) {
    		this.dom.parentNode.removeChild(this.dom);
    		this.dom = null;
    	}
    };

    SMRoomMarker.prototype.getPosition = function() {
    	return this.latlng;
    };
  }

  updateMarkers() {

    this.markers.forEach((marker)=>{
      marker.setMap(null);
    });
    this.markers = [];

    let selected = [];
    let entered = [];
    let rooms = [];
    this.props.rooms.forEach((room)=>{
      if (this.props.mouseEnterRoom && this.props.mouseEnterRoom.id == room.id) {
        entered.push(room);
      }
      else if (this.state.selectedRoom && this.state.selectedRoom.id == room.id) {
        selected.push(room);
      }
      else {
        rooms.push(room);
      }
    });
    rooms = rooms.concat(selected).concat(entered);

    rooms.forEach((room)=>{
      let className = "";
      if (this.props.mouseEnterRoom && this.props.mouseEnterRoom.id == room.id) {
        className = "is-current";
      }
      else if (this.state.selectedRoom && this.state.selectedRoom.id == room.id) {
        className = "is-active";
      }
      else if (this.visitedRooms.indexOf(room.id) != -1) {
        className = "is-visited";
      }
      const marker = new SMRoomMarker(room, className, this.googleMap.map, {draggable: false});
      this.markers.push(marker);
      google.maps.event.addListener(marker, 'click', (e) => {
        if (this.state.selectedRoom && this.state.selectedRoom.id == room.id) {
          this.setState({selectedRoom: null});
        } else {
          this.setState({selectedRoom: room});
        }
        if (this.visitedRooms.indexOf(room.id) == -1) {
          this.visitedRooms.push(room.id);
        }
      });
    });
  }

  favoriteDidSelect(room, isFavorite){
    if(this.props.delegate && typeof this.props.delegate.favoriteDidSelectOnMap === 'function'){
      this.props.delegate.favoriteDidSelectOnMap(room, isFavorite);
    }
  }

  render() {
    return(
      <div>
        <div className="js-search-list__map-canvas" ref="mapCanvas" />
        <SMSearchMapRoomView
          currentUser={this.props.currentUser}
          room={this.state.selectedRoom}
          searchSessionId={this.props.searchSessionId}
          delegate={this} />
      </div>
    );
  }

}
export default SMSearchMapView;



// WEBPACK FOOTER //
// ./app/javascript/components/search/SMSearchMapView.jsx